import React, { useState, useEffect, useRef } from 'react';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, MenuItem, Grid, TableContainer,Table, TableHead, TableBody, TableRow, TableCell, Paper, DialogActions, InputLabel, Select, DialogContent, DialogContentText, Dialog, DialogTitle, FormControl, Stack, Divider } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import styled from '@emotion/styled';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
const validationSchema = Yup.object().shape({
  purchaseDate: Yup.date().required('Purchase Date is required'),
  paymentTerm: Yup.string().required('Payment Term is required'),
});

const types = [{name:'Memo Purchase',val:28},{name:'Consginment',val:29}]; // Options for the select dropdown

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
function MemoInRC() {
  const [helperdata,setHelperdata]= useState({})
  const [billdata,setBildata]= useState([])
  const [memorcdata,setmemorcdata]= useState([])
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedBillNO, setselectedBillNO] = useState('');
  const [summeryData, setsummeryData] = useState(false);
  const dataGridRef = useRef(null);
  useEffect(() => {
    jwtAuthAxios.get(`master/helper?term=1`).then((res) => {
      setHelperdata(res.data?.data)
    }).catch(alert)
    // fetchBasketdata();
  }, []);
  // const [selectedMemorcdata,setselectedMemorcdata]= useState([])
  let selectedMemorcdata=[];
  const handleSubmit = (values, { setSubmitting }) => {
    // Call your API here with form values
    console.log(values);
    setSubmitting(false);
  };
  console.log(selectedMemorcdata);
  const init=async()=>{
    await jwtAuthAxios.get('acc/getmemorcdetailsinward?type=b').then(res=>
      {setBildata(res.data)}).catch(alert)
  }
  useEffect(async () => {
    init()
  
  }, [])
  
  const handlebillData=async(e)=>{
    selectedBillNO && await jwtAuthAxios.get('acc/getmemorcdetailsinward?bill='+selectedBillNO).then(res=>
      {setmemorcdata(res.data);}).catch(alert)
  }
  useEffect(()=>{
    selectedBillNO && handlebillData()
  },[selectedBillNO])
  const columns = [
    { field: 'FL_SRNO', headerName: 'NO', flex:1 },
    { field: 'FL_STONE_ID', headerName: 'LOT NO', flex:1 },
    // { field: 'FL_PCS', type:'number',headerName: 'Original PCS', flex:1,renderCell:({value})=>Number(value||0)?.toFixed(2) },
    // { 
    //   field: 'editablePCS', 
    //   headerName: 'PCS', 
    //   flex:1, 
    //   cellClassName: 'editable-cell',
    //   type:'number',
    //   editable:true,

    // },
    { field: 'FL_CARATS',type:'number', headerName: 'Original CARATS', flex:1,renderCell:({value})=>Number(value||0)?.toFixed(2) },
    { 
      field: 'editableCARATS', 
      headerName: 'CARATS', 
      flex:1, 
      cellClassName: 'editable-cell',
      type:'number',
      editable:true
    },
    { field: 'FL_RET_CTS',type:'number', headerName: 'Return CARATS', flex:1,renderCell:({value})=>Number(value||0)?.toFixed(2) },
    { field: 'FL_KEPT_CTS',type:'number', headerName: 'Confirm CARATS', flex:1,renderCell:({value})=>Number(value||0)?.toFixed(2) },
    { field: 'FL_PRICE',type:'number', headerName: 'RATE', flex:1,renderCell:({value})=>Number(value||0)?.toFixed(2) ,type:'number'},
    { field: 'FL_AMT1',type:'number', parmsheaderName: 'AMT', flex:1,renderCell:(params)=>(Number(params?.row?.FL_PRICE||0)*Number(params?.row?.FL_CARATS||0))?.toFixed(2) },
  ];

  const formattedData = memorcdata?.map((item,i) => ({
    ...item,
    id:`${item.FL_STONE_ID}-${item.FL_SRNO}`,
    editablePCS: item.FL_PCS,
    editableCARATS: item.FL_CARATS,
  }));
  const handleCellEditCommit = (params) => {
    console.log(params);
    const updatedRows = memorcdata.map(row =>
      row.id === params.id ? { ...row, [params.field]: params.value } : row
    );
    setmemorcdata(updatedRows);
  };
  const swal = useSwalWrapper()

  const handleFormSubmit =async (values) => {
    // console.log("Form values:", values);
    await jwtAuthAxios.post('acc/memoinrc',{...values,data:summeryData?.data,type:'C'}).then(res=>{
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      setmemorcdata([])
      handlebillData()
    setOpenDialog(!openDialog)
    }).catch(alert)
    // Perform form submission logic here
  };
  const handleMemoINRCDIaloge= async()=>{
    let sled= await selectedMemorcdata.map(data=>dataGridRef.current.getRow(data))
    let pcs = sled?.length
    let cts = sled?.reduce((acc, obj) => acc + obj.editableCARATS, 0);
    let rap = sled?.reduce((acc, obj) => acc + obj.FL_RAP, 0) / sled?.length;
    let disc = sled?.reduce((acc, obj) => acc + obj.FL_DISC, 0)/ sled?.length;
    // let amt = sled?.reduce((acc, obj) => acc + obj.FL_AMT1, 0)/ sled?.length;
    console.log({data:sled,sum:{pcs,cts,rap,disc}});
    setsummeryData({data:sled,sum:{pcs,cts,rap,disc}});
    setOpenDialog(!openDialog)
  }
  const handlememoreturn = async()=>{
    let sled= await selectedMemorcdata.map(data=>dataGridRef.current.getRow(data))
    if(window.confirm('are you sure to return stone ('+sled?.length+')')){
      await jwtAuthAxios.post('acc/memoinrc',{data:sled,type:'R'}).then(res=>{
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        setmemorcdata([])
        handlebillData()
      // setOpenDialog(!openDialog)
      }).catch(alert)
    }
    
  }
  return (
    <div>
      {/* <Formik
      initialValues={{
        startDate: '',
        type: '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => ( */}
        {/* <Form> */}
          <Grid container spacing={2} row>
          {/* <Grid item lg={4}>
          <Field name="startDate">
            {({ field, meta }) => (
              <TextField
                {...field}
                label="Start Date"
                type="date"
                fullWidth
                error={meta.touched && meta.error}
                helperText={meta.touched && meta.error}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </Field>
          </Grid>
           */}
          <Grid item lg={4}>
          {/* <Field name="billno">
            {({ field, meta }) => ( */}
              <TextField
                // {...field}
                select
                label="Select Bill"
                size='small'
                fullWidth
                value={selectedBillNO}
                onChange={e=>setselectedBillNO(e.target.value)}
                // error={meta.touched && meta.error}
                // helperText={meta.touched && meta.error}
              >
                {billdata.map((option) => (
                  <MenuItem key={option?.FL_BILL_NO} value={option.FL_BILL_NO}>
                    {option.FL_BILL_NO}
                  </MenuItem>
                ))}
              </TextField>
            {/* )}
          </Field> */}
          </Grid>
          <Grid item lg={8} alignItems={'end'} sx={{textAlign: 'end'}}>
            <Button variant='contained' onClick={handleMemoINRCDIaloge}> Confirm</Button>
            <Button variant='contained' sx={{ml:2}} onClick={handlememoreturn}> Return</Button>
          </Grid>
          </Grid>
        {/* </Form> */}
      {/* )}
    </Formik> */}
    {/* <button onClick={()=>console.log(selectedMemorcdata)}>button</button> */}
    <Paper sx={{ mt: 3, height: 400 }}>
      <DataGrid
        rows={formattedData}
        columns={columns}
        pageSize={5}
        getRowClassName={({row})=>(row?.FL_RET_CTS+row?.FL_KEPT_CTS) ==row.FL_CARATS && 'cell_not_editavle'}
        disableRowSelectionOnClick
        apiRef={dataGridRef}
        onRowSelectionModelChange={e=>selectedMemorcdata=e}
        isCellEditable={(params)=>params?.row?.FL_DIAMOND_TYPE !== 'POLISH-SINGLE'}
      density='compact'
      // onCellEditStop={handleCellEditCommit}
        rowsPerPageOptions={[5, 10, 20]}
        checkboxSelection
        // rowSelection={}
        isRowSelectable={({row})=>(row?.FL_RET_CTS+row?.FL_KEPT_CTS) !=row.FL_CARATS}
      />
    </Paper>
    <Dialog open={openDialog} fullWidth onClose={(e)=>setOpenDialog(!openDialog)}>
          <DialogTitle>Memo Confirm</DialogTitle>
          <Formik
        initialValues={{ purchaseDate: '', paymentTerm: '' }}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur }) => (
          <Form>
            <DialogContent>
              <Field
                as={TextField}
                name="purchaseDate"
                type="date"
                label="Purchase Date"
                fullWidth
                value={values.purchaseDate}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.purchaseDate && Boolean(errors.purchaseDate)}
                helperText={touched.purchaseDate && errors.purchaseDate}
                
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <FormControl sx={{mt:2}} fullWidth error={touched.paymentTerm && Boolean(errors.paymentTerm)}>
                <InputLabel id="paymentTermLabel">Payment Term</InputLabel>
                <Field
                  as={Select}
                  name="paymentTerm"
                  labelId="paymentTermLabel"
                  label="Payment Term"
                  value={values.paymentTerm}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                 {helperdata?.TERM?.map((option) => (
                    <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
                      {option.FL_TERM_NAME}
                    </MenuItem>
                  ))}
                </Field>
              </FormControl>
    
    <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1, mt: 3 }} >
                  <Item>Lot  {summeryData?.sum?.pcs || 0}</Item>
                  <Item>CTS  {(summeryData?.sum?.cts ||0)?.toFixed(2)}</Item>
                  <Item>Rap  {(summeryData?.sum?.rap || 0).toFixed(2)}</Item>
                  <Item>Disc%  {(summeryData?.sum?.disc || 0)?.toFixed(2) || 0}</Item>
                  {/* <Item>vat%  {values.wat_per || 0}</Item> */}
                </Stack>
            </DialogContent>
            <DialogActions>
              <Button variant='outlined' color='error' onClick={(e)=>setOpenDialog(!openDialog)}>Cancel</Button>
              <Button type="submit" variant='contained' color="primary">Submit</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
      
      </Dialog>
    </div>
  )
}


MemoInRC.Modulename = 'Party'

export default MemoInRC;